import { RouteConfig } from 'vue-router';

import FaqPage from './faq.vue';
import { RouteName } from '../../routes.constants';
import { getPagesComponent } from '../pages.routes';

export const FaqRoutes: RouteConfig[] = [
    {
        path: '',
        component: FaqPage,
        children: [
            {
                name: RouteName.FAQ_CATEGORIES,
                path: '',
                component: getPagesComponent('FaqCategoriesPage'),
                meta: {
                    timedOutAllowed: true,
                },
            },
            {
                name: RouteName.FAQ_SEARCH,
                path: 'search',
                component: getPagesComponent('FaqSearchPage'),
                meta: {
                    timedOutAllowed: true,
                },
            },
            {
                name: RouteName.FAQ_ENTRIES,
                path: ':categorySlug',
                component: getPagesComponent('FaqEntriesPage'),
                meta: {
                    timedOutAllowed: true,
                },
            },
        ],
    },
];
